module.exports = __webpack_public_path__ + "img/11.8d654475.png";